/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentTypeResponse } from '../../models/attachment-type-response';
import { BaseResponse } from '../../models/base-response';

export interface CommonControllerGetAttachmentTypes$Params {
  type: number;
}

export function commonControllerGetAttachmentTypes(http: HttpClient, rootUrl: string, params: CommonControllerGetAttachmentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentTypeResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerGetAttachmentTypes.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AttachmentTypeResponse;
      }>;
    })
  );
}

commonControllerGetAttachmentTypes.PATH = '/common/attachment-types/{type}';
